export const Balance_Amounts_Action_Types = {
    FETCH_BALANCES_START: "balances/FETCH_BALANCES_START",
    FETCH_BALANCES_SUCCESS: "balances/FETCH_BALANCES_SUCCESS",
    FETCH_BALANCES_FAILED: "balances/FETCH_BALANCES_FAILED",
    SET_PAGE_SIZE: "balances/SET_PAGE_SIZE",
    RESET_STATE: "balances/RESET_STATE",
    SET_FILTER_SEARCH_STRING: "balances/SET_FILTER_SEARCH_STRING",
    SET_IS_UPDATED: "balances/SET_IS_UPDATED"
}